import { FetchDepartmentMembersParam, FetchDepartmentMembersResponse } from '@@types/Api/Department';
import { ContentWrap, DEPARTMENT_ID, POSITION_ID } from '@@types/common';
import Department from '@@types/Department';
import DepartmentResponse from '@@types/Department/Response';
import { Position } from '@@types/Position';

import { ALL_API_SIZE, URLS } from '~/constants';
import Api2 from '~/stores/providers/Api2';
import rename from '~/utils/fnUtil/rename';
import { evolve } from 'ramda';

class DepartmentApi {
  constructor(private api: Api2) {}

  fetchDepartment = (departmentId: DEPARTMENT_ID): Promise<DepartmentResponse> => {
    return (
      this.api.resultRequester.get(`${URLS.WAS_API}/departments/${departmentId}`) as Promise<DepartmentResponse>
    ).then((res: DepartmentResponse) => {
      return evolve({ content: rename({ departmentId: 'id' }) }, res);
    });
  };

  fetchDepartmentMembers = (params: FetchDepartmentMembersParam): Promise<FetchDepartmentMembersResponse> => {
    return this.api.resultRequester.post(`${URLS.WAS_API}/members/fetch-by-department`, null, {
      headers: { 'Content-Type': 'application/json' },
      params: rename({ include: 'includeSubDepts' }, params),
    });
  };

  fetchJobPosition = (positionId: POSITION_ID): Promise<ContentWrap<Position>> => {
    return this.api.resultRequester.get(`${URLS.WAS_API}/job-positions/${positionId}`);
  };

  fetchPrimaryDepartments = (): Promise<Department[]> => {
    return this.api.contentsRequester.get(
      `${URLS.WAS_API}/departments?type=organization&size=10000&order=displayOrder`
    );
  };

  fetchSubDepartments = (parentDepartmentId: DEPARTMENT_ID): Promise<Department[]> => {
    return this.api.contentsRequester.get(`${URLS.WAS_API}/departments`, {
      params: { parentDepartmentId, order: 'displayOrder', size: ALL_API_SIZE },
    });
  };
}

export default DepartmentApi;
